import { FC, useState } from 'react';
import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { useAlertsDetectOriginProvider } from '../../../../shared/contexts/AlertsDetectOriginContext';
import { ErrorBoundary } from '../../../../shared/utils/errorReporting/ErrorBoundary';
import { useIsMobileOrTablet } from '../../../../shared/utils/helpers/util';
import { CornerWrapper } from '../../../components/ExpandableNotesContainer/ExpandableNotesContainer.styles';
import { ALERTS_HEADING_HEIGHT } from '../../PageHeading/constants';

import { AccountNotes } from './AccountNotes';
import { RideNotes, SkeletonRideNotes } from './RideNotes';

const SRS_PANEL_HEIGHT = 222;

export const SrsPanel: FC = () => {
  const [maximizedNote, setMaximizedNote] = useState<string | null>(null);
  const isMobileOrTablet = useIsMobileOrTablet();
  const { isAlertsReferrer } = useAlertsDetectOriginProvider();

  const heightOffset = `${isAlertsReferrer ? SRS_PANEL_HEIGHT + ALERTS_HEADING_HEIGHT : SRS_PANEL_HEIGHT}px`;

  const handleNoteClick = (noteId: string) => {
    setMaximizedNote((prev) => (prev === noteId ? null : noteId));
  };

  const getNoteState = (noteId: string) => {
    if (maximizedNote === noteId) {
      return 'maximized';
    }
    if (maximizedNote) {
      return 'minimized';
    }

    return 'default';
  };

  return (
    <Box display="flex" flexDirection="column" height={`calc(100vh - ${isMobileOrTablet ? '362px' : heightOffset})`}>
      <ErrorBoundary FallbackComponent={SkeletonRideNotes}>
        <RideNotes id="Ride" state={getNoteState('Ride')} onClick={() => handleNoteClick('Ride')} />
      </ErrorBoundary>
      <ErrorBoundary>
        <AccountNotes id="Account" state={getNoteState('Account')} onClick={() => handleNoteClick('Account')} />
      </ErrorBoundary>
    </Box>
  );
};

export const Heading = ({ id, state, onClick }) => {
  return (
    <Box display="flex" flexDirection="column" gap="20px" sx={{ width: '100%' }}>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap="6px">
          <Svg icon="note" width="24px" height="24px" />
          <Text variant="h6" textColor="primaryText">
            {id} Notes (Internal)
          </Text>
        </Box>
        <CornerWrapper onClick={onClick}>
          <Svg icon={state === 'maximized' ? 'collapse' : 'expand'} />
        </CornerWrapper>
      </Box>
    </Box>
  );
};
